import React from 'react'
import {Modal} from 'react-bootstrap'
import {Navigate, useNavigate} from 'react-router-dom'
import {KTSVG} from '../../_metronic/helpers'

const PaymentSuccessPopup = ({show, handleClose, button, backdrop, restData}: any) => {
  const navigate = useNavigate()
  return (
    <>
      <Modal
        id='kt_modal_create_app'
        backdrop={backdrop ? backdrop : 'static'}
        tabIndex={-1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-500px h-auto celebration-modalpopup'
        show={show}
        onHide={handleClose}
      >
        <div className='container-xxl p-0'>
          <div className='modal-body border-bottom campaign-model'>
            <div className='confetti'>
              {Array(13)
                .fill('')
                .map((_, i: number) => (
                  <div key={i} className='confetti-piece'></div>
                ))}
            </div>
            <div className='row'>
              <div className='col-md-12 text-center'>
                <h2>
                  You did it! <br /> You're ready to go.
                </h2>
                <p
                  style={{
                    margin: '16px 0px 42px 0px',
                  }}
                >
                  You can see you purchase activity and <br /> invoices on the billing tab under
                  your profile. <br /> Make sure you set auto top-up
                </p>
              </div>
            </div>

            <div className='d-flex align-items-center justify-content-center'>
              <button
                type='submit'
                className='btn btn-lg btn-light-primary me-5 fw-500'
                onClick={() => {
                  handleClose()
                  navigate('/accounts/billing')
                }}
              >
                <span className='indicator-label'>Set auto top-up</span>
              </button>
              <button
                type='submit'
                className='btn btn-lg  btn-primary me-5 fw-500'
                onClick={() => {
                  handleClose()
                  navigate('/new-message')
                }}
              >
                <span className='indicator-label'>Send campaign</span>
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default PaymentSuccessPopup
